import { DefaultOptionType } from 'antd/lib/select';

export const toSelectOptions = (
  values: string[] | number[],
): DefaultOptionType[] => values.sort().map((value) => ({ value, label: value }));
